<div class="contentHeight">
    <!--<h1 class="text-center containerTitle">Monitoring interne</h1>-->


    <div class="row col-xl-11 col-lg-11 col-md-12 mx-auto">
        <button id="btnLogLacourEdit" class="btn btn-light mr-3" (click)="showLogLacourEditData()">Logs Modifs Lacour</button>
        <button id="btnErrorLog" class="btn btn-light mr-3" (click)="showErrorLogData()">ErrorLog</button>
        <button id="btnLog" class="btn btn-light mr-3" (click)="showLogData()">Log</button>
        <button id="btnLogAccesClient" class="btn btn-light" (click)="showLogAccesClientData()">Log accès client</button>
        <div class="flex-grow-1"></div>
        <mat-form-field class="mat-form-field-with-bg nb-days-field" subscriptSizing="dynamic">
            <mat-label>Nombre de jours</mat-label>
            <input type="number" matInput min="1" [(ngModel)]="nbDays" (input)="refresh()">
        </mat-form-field>
    </div>
    <div class="row mx-auto adminContent">
        <div class="col-xl-11 col-lg-11 col-md-12 mx-auto" *ngIf="showLogLacourEdit">
            <table class="table bg-white respTab logLacourEditTable">
                <thead class="bg-white">
                    <tr>
                        <th>N°</th>
                        <th>Date</th>
                        <th>Cellule modifiée</th>
                        <th>Ancienne valeur</th>
                        <th>Nouvelle valeur</th>
                        <th>Auteur</th>
                        <th>Action</th>
                    </tr>
                    <tr class="headLine"><td colspan="7"></td></tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let logLacourEditGroup of logLacourEditLst; index as gI">
                        <tr *ngFor="let logLacourEdit of logLacourEditGroup; index as lI" [style.backgroundColor]="((gI % 2) === 0) ? '#EEEEEE' : null">
                            <td>{{logLacourEdit.logLacourEditID}}</td>
                            <td>{{getProperDate(logLacourEdit.date)}}</td>
                            <td>{{getProperValue(logLacourEdit.valueName, logLacourEdit.pKey)}}</td>
                            <td>{{logLacourEdit.oldValue}}</td>
                            <td>{{logLacourEdit.newValue}}</td>
                            <td>{{logLacourEdit.author}}</td>
                            <td class="rewindCell" *ngIf="lI === 0" [attr.rowspan]="logLacourEditGroup.length" [style.textAlign]="'center'">
                                <span class="pointer steelblue" *ngIf="logLacourEdit.reversible" [style.fontSize]="'2rem'" (click)="rewind(logLacourEdit.logLacourEditID)" title="Rétablir"><i class="fas fa-history"></i></span>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="col-xl-11 col-lg-11 col-md-12 mx-auto" *ngIf="showErrorLog">
            <!--<h3 class="text-center">ErrorLog</h3>-->
            <mat-form-field class="ml-2">
                <mat-label>Rechercher</mat-label>
                <input matInput (keyup)="applyFilter($event.target.value,'errorLog')">
            </mat-form-field>
            <div class="table-wrapper-scroll-y noOverflow">
                <mat-table class="table bg-white respTab table-hover" [dataSource]="errorSource" matSort (matSortChange)="sortScale($event,'1')">
                    <!-- ID -->
                    <ng-container matColumnDef="errorID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Code</mat-header-cell>
                        <mat-cell *matCellDef="let erreur">{{erreur.iderrorlog}}</mat-cell>
                    </ng-container>
                    <!-- Code -->
                    <ng-container matColumnDef="errorCode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Code</mat-header-cell>
                        <mat-cell *matCellDef="let erreur">{{erreur.code}}</mat-cell>
                    </ng-container>
                    <!-- Date -->
                    <ng-container matColumnDef="errorDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
                        <mat-cell *matCellDef="let erreur">{{ erreur.date | date:'dd/MM/yyyy HH:mm:ss' }}</mat-cell>
                    </ng-container>
                    <!-- Description -->
                    <ng-container matColumnDef="errorDescription">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
                        <mat-cell *matCellDef="let erreur" style="word-break: break-all;">{{ erreur.description }}</mat-cell>
                    </ng-container>
                    <!-- Paramètres -->
                    <ng-container matColumnDef="errorParameters">
                        <mat-header-cell *matHeaderCellDef>Paramètres</mat-header-cell>
                        <mat-cell *matCellDef="let erreur" style="word-break: break-all;">{{erreur.parameters}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
            </div>
        </div>
        <div class="col-xl-11 col-lg-11 col-md-12 mx-auto" *ngIf="showLog">
            <!--<h3 class="text-center">Log</h3>-->
            <mat-form-field class="ml-2">
                <mat-label>Rechercher</mat-label>
                <input matInput (keyup)="applyFilter($event.target.value,'log')">
            </mat-form-field>
            <div class="table-wrapper-scroll-y noOverflow">
                <mat-table class="table bg-white respTab table-hover" [dataSource]="logSource" matSort (matSortChange)="sortScale($event,'1')">
                    <!-- ID -->
                    <ng-container matColumnDef="logId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.logID}}</mat-cell>
                    </ng-container>
                    <!-- Date -->
                    <ng-container matColumnDef="logDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.logDate | date:'dd/MM/yyyy HH:mm:ss' }}</mat-cell>
                    </ng-container>
                    <!-- Catégorie -->
                    <ng-container matColumnDef="logCategorie">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Catégorie</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.categoryLogName}}</mat-cell>
                    </ng-container>
                    <!-- Sous-catégorie -->
                    <ng-container matColumnDef="logSouscategorie">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Sous-catégorie</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.subCategoryLogName}}</mat-cell>
                    </ng-container>
                    <!-- Evènement -->
                    <ng-container matColumnDef="logEvenement">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Evènement</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.evenement}}</mat-cell>
                    </ng-container>
                    <!-- Infos -->
                    <ng-container matColumnDef="logInfos">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Infos</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.infosComp}}</mat-cell>
                    </ng-container>
                    <!-- Login -->
                    <ng-container matColumnDef="logLogin">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Login</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.login}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
            </div>
        </div>
        <div class="col-xl-11 col-lg-11 col-md-12 mx-auto" *ngIf="showLogAccesClient">
            <!--<h3 class="text-center">Log accès client</h3>-->
            <mat-form-field class="ml-2">
                <mat-label>Rechercher</mat-label>
                <input matInput (keyup)="applyFilter($event.target.value,'logAccesClient')">
            </mat-form-field>
            <button class="export boutonExport" (click)="ExportLogAccesClient()">Export Excel</button>
            <div class="table-wrapper-scroll-y noOverflow">
                <mat-table class="table bg-white respTab table-hover" [dataSource]="logAccesClientSource" matSort (matSortChange)="sortScale($event,'1')">
                    <!-- ID -->
                    <ng-container matColumnDef="logId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.logID}}</mat-cell>
                    </ng-container>
                    <!-- Date -->
                    <ng-container matColumnDef="logDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.logDate | date:'dd/MM/yyyy HH:mm:ss' }}</mat-cell>
                    </ng-container>
                    <!-- Catégorie -->
                    <ng-container matColumnDef="logCategorie">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Catégorie</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.categoryLogName}}</mat-cell>
                    </ng-container>
                    <!-- Sous-catégorie -->
                    <ng-container matColumnDef="logSouscategorie">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Sous-catégorie</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.subCategoryLogName}}</mat-cell>
                    </ng-container>
                    <!-- Evènement -->
                    <ng-container matColumnDef="logEvenement">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Evènement</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.evenement}}</mat-cell>
                    </ng-container>
                    <!-- Infos -->
                    <ng-container matColumnDef="logInfos">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Infos</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.infosComp}}</mat-cell>
                    </ng-container>
                    <!-- Login -->
                    <ng-container matColumnDef="logLogin">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Login</mat-header-cell>
                        <mat-cell *matCellDef="let log">{{log.login}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
            </div>
        </div>
    </div>
</div>


<!-- Modal - Erreur de rétablissemrnt d'un log d'édition Lacour -->
<div id="errorLogLacourRewindModal" class="modal">
    <div class="modal-content2" [style.height]="'auto'">
        <div class="row">
            <span class="col-12 text-right pointer close" (click)="closeModal('errorLogLacourRewindModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <div class="col-12 mx-auto text-center flex flex-column flex-center">
                <h1> Erreur </h1>
                <p [style.whiteSpace]="'wrap'">{{rewindMessage}}</p>
                <button class="btn btn-secondary" (click)="closeModal('errorLogLacourRewindModal')"> Fermer </button>
            </div>
        </div>
    </div>
</div>
